// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-text-field--outlined input {\r\n  font-size: 11pt;\n}\n.v-text-field--outlined label {\r\n  font-size: 14px;\n}\n.pointer {\r\n  color: cornflowerblue;\r\n  cursor: pointer;\n}\n.pointer-disable {\r\n  cursor: pointer;\n}\r\n", ""]);
// Exports
module.exports = exports;
